export const WAITING_STATUS = 'waiting'
export const IN_PROCESS_STATUS = 'in_process'
export const SUCCESS_STATUS = 'success'
export const INVALID_FORMAT_STATUS = 'invalid_format'
export const EXCEEDS_MAXIMUM_STATUS = 'exceeds_maximum'
export const ERROR_STATUS = 'error'
export const CONVERTINATOR_MAX_SIZE_IN_MEGA_BYTES = "150 mb";